<template lang="pug">
  div
    el-row
      divider(label="Dados do Ofício")
    el-row(type='flex' :gutter="24")
      el-col(:span="4").container-input
          app-label(label="Dados do Anexo:" :required="false")
          el-select.input(
            name='Dados do Anexo'
            class="select",
            no-match-text="Nenhum dado encontrado",
            placeholder="Selecione",
            v-model="anexoEscolhido"
            value-key="id"
            filterable,
            clearable,
          )
            el-option(
              v-for="dado in dadosAnexos",
              :key="dado.codigo",
              :label="dado.codigo",
              :value="dado"
            )

      el-col(:span="10" v-for="label, ind in anexoEscolhido.labels" :key="label").container-input
          app-label(:label="label")
          el-input.input(
            v-model="anexos[label]"
            :class="{'erro': errors[label] && !errors[label].isValid}"
            @change="validate(label)"
          )
          span.erro.help(v-if="errors[label] && !errors[label].isValid") {{errors[label].message}}
      el-col(:span="3" v-if="Object.keys(anexoEscolhido).length").container-input.align-center
        el-button(@click="adicionaAnexo" type="success" icon="el-icon-circle-plus")
        span.adicionar Adicionar
    el-row
      div.wrap-collabsible(v-if="dadosTables.some(dado => dado.dados.length)")
        el-collapse(accordion :value="acordionActive")
          el-collapse-item(
            v-for="dados in dadosTables"
            :key="dados.codigo"
            :title="dados.codigo"
            :name="dados.codigo"
            v-if="dados.dados.length"
            )
            table-generica(
              :dados="dados.dados"
              :colunas="dados.colunas"
              :config="tableConfig"
              :isOneAction="true"
              :botoesAcao="excluirAnexo"
              )
</template>

<script>
import Divider from '@/screens/arrecadacao/components/Divider'
import AppLabel from '@/components/AppLabel'
import TableGenerica from '@/components/TableGenerica'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {
  components: {
    Divider,
    AppLabel,
    TableGenerica
  },

  props: {
    dadosAnexos: {
      required: true,
      type: Array
    }
  },

  data () {
    return {
      anexos: {},
      anexoEscolhido: {},
      dadosTables: [],
      tableConfig: { border: true, stripe: true },
      count: 0,
      acordionActive: null,
      errors: {}
    }
  },

  mixins: [AppNotificacao],

  created () {
    this.dadosTables = this.dadosAnexos.map(({ codigo, labels, nome }) => ({
      codigo,
      nome,
      dados: [],
      colunas: labels.map(label => ({
        prop: label,
        label: label
      }))
    }))
  },

  methods: {
    async adicionaAnexo () {
      const isNotValid = this.anexoEscolhido.labels.some(label => !this.anexos[label])
      if (isNotValid) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERRO_VALIDACAO_CAMPOS_OBRIGATORIOS
        )
        return
      }
      this.dadosTables = this.dadosTables.map(dado => {
        if (dado.codigo === this.anexoEscolhido.codigo) {
          const aux = [...dado.dados]
          aux.push({
            ...this.anexos,
            id: `${dado.codigo}-${this.count}`
          })
          this.count += 1
          this.acordionActive = dado.codigo
          return {
            ...dado,
            dados: [...aux]
          }
        }
        return { ...dado }
      })
      this.anexos = {}
      Object.keys(this.errors).forEach(
        key => (this.errors[key].isValid = false)
      )
      this.setAnexosDTO()
    },

    excluirAnexo (anexo) {
      this.dadosTables = this.dadosTables.map(dado => {
        let aux = [...dado.dados]
        aux = aux.filter(el => el.id !== anexo.id)
        return {
          ...dado,
          dados: [...aux]
        }
      })
      this.setAnexosDTO()
    },

    setAnexosDTO () {
      const anexosDTO = this.dadosTables
        .map(dados => {
          if (dados.dados.length) {
            return {
              header: dados.nome,
              labels: dados.colunas.map(prop => prop.label),
              dados: dados.dados
            }
          }
        })
        .filter(dado => {
          return dado !== undefined
        })
      this.$emit('atualizarAnexos', anexosDTO)
    },

    async validate (label) {
      if (label) {
        if (!this.anexos[label] || this.anexos[label].length === 0) {
          this.errors[label].isValid = false
          return false
        } else {
          this.errors[label].isValid = true
          return true
        }
      }
      return Object.keys(this.errors).every(
        key =>
          this.errors[key].codigo !== this.anexoEscolhido.codigo ||
          (this.errors[key] && this.errors[key].isValid)
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/element-variables.scss';

.container-input {
  margin-right: 20px;
}

.wrap-collabsible {
  margin-top: 15px;
}

>>> .el-collapse-item__header {
  font-size: 17px;
  text-align: center;
  align-self: center;
  justify-content: center;
}

.input-suffix {
  padding: 10px;
}

>>> .el-input-group__append {
  color: $--color-text-secondary;
}

>>> .el-icon-circle-plus {
  font-size: 1.6rem;
}

>>> .el-button--success {
  padding: 5px;
  margin-top: 18px;
}
.adicionar {
  margin-left: 10px;
  margin-top: 18px;
}

.align-center {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/cpat/components/oficio/DadosOficioInteiroTeor.vue